import { notify, notifyError } from "../../../../utils/toast";
import { gql } from "../../../../__generated__";
import { useMutation } from "@apollo/client";
import { GET_PACK_ORDERS } from "../../api/pack-order-queries";

const CANCEL_PACK_ORDERS = gql(`
  mutation CancelPackOrders($orderIds: [Int!]!, $cancelReason: String!) {
    cancelPackOrders(orderIds: $orderIds, cancelReason: $cancelReason) {
      ok
      error
    }
  }
`);

interface CancelOrdersResult {
  /** 주문 일괄 취소 함수 */
  cancelOrders: (orderIds: number[], cancelReason?: string) => Promise<void>;
  loading: boolean; // 주문 일괄 취소 로딩 상태
}

/**
 * 주문 일괄 취소 서버 요청 훅
 *
 * 선택된 여러 주문을 한 번에 취소할 수 있는 GraphQL mutation 훅입니다.
 * 취소 완료 후 자동으로 주문 목록을 새로고침하고 성공/실패 알림을 표시합니다.
 */
export function useCancelOrders(): CancelOrdersResult {
  const [cancelPackOrders, { loading }] = useMutation(CANCEL_PACK_ORDERS, {
    refetchQueries: [{ query: GET_PACK_ORDERS }],
    awaitRefetchQueries: true,
  });

  const cancelOrders = async (
    orderIds: number[],
    cancelReason: string = ""
  ) => {
    try {
      const { data } = await cancelPackOrders({
        variables: { orderIds, cancelReason },
      });

      if (data?.cancelPackOrders.ok) {
        notify(`${orderIds.length}건의 주문이 취소되었습니다.`);
      } else {
        notifyError(
          data?.cancelPackOrders.error || "주문 취소에 실패했습니다."
        );
      }
    } catch (err: any) {
      notifyError(err.message);
    }
  };

  return { cancelOrders, loading };
}
